import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function RouteAccessibility() {
  const { pathname } = useLocation();
  useEffect(() => {
    const main = document.getElementById("main-content");
    main?.focus({ preventScroll: true });
    window.scrollTo?.({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
